const Header = () => {
  return (
    <header className="site-header">
      <div className="header-content">
        <div className="brand">
          <div>
            <p className="brand-title">Projects Portfolio</p>
            <p className="brand-subtitle">Computer Science Major</p>
          </div>
        </div>
        <nav className="nav-links" aria-label="Primary navigation">
          <a href="#projects">Projects</a>
          <a href="#experience">Experience</a>
          <a href="#contact">Contact</a>
        </nav>
      </div>
    </header>
  );
};

export default Header;
